import React from "react"
import { Link } from "gatsby"
import { classNames } from "../../utils/classNames"
import { turnMdToHtml } from "../../utils"

type GeneralCallToActionButton = {
  text: string
  additionalText?: string
}

type CallToActionButtonWithOnClick = {
  onClick: () => void
  link?: never
} & GeneralCallToActionButton

type CallToActionButtonWithLink = {
  link: string
  onClick?: never
} & GeneralCallToActionButton

interface CallToActionProps {
  h2: string
  description: string
  button: CallToActionButtonWithLink | CallToActionButtonWithOnClick
  furtherButton?: CallToActionButtonWithLink | CallToActionButtonWithOnClick
  whiteBackground?: true
  grayBackground?: true
  maxWidthH2: number
  maxWidth?: number
  color?: "red" | "white" | "gray"
  spacing?: number
  smallSpacing?: number
}

export const CallToAction = ({
  h2,
  description,
  button,
  whiteBackground,
  maxWidthH2,
  grayBackground,
  furtherButton,
  color,
  spacing = 24,
  maxWidth = 900,
  smallSpacing = 12,
}: CallToActionProps) => {
  switch (color) {
    case "white":
      whiteBackground = true
      break
    case "gray":
      grayBackground = true
      break
    default:
      break
  }
  return (
    <div
      className={classNames(
        whiteBackground || grayBackground
          ? whiteBackground
            ? `bg-white text-black py-${smallSpacing}`
            : `bg-lightgray py-${spacing}`
          : `bg-orange text-white py-${spacing}`,
        ""
      )}
    >
      <div
        className={`px-4 sm:px-6 mx-auto text-center`}
        style={{ maxWidth: maxWidth + "px" }}
      >
        <h2
          style={{ maxWidth: maxWidthH2 + "ch", overflowWrap: "anywhere" }}
          className={"pb-8 text-[32px] font-semibold font-serif mx-auto"}
        >
          {h2}
        </h2>
        <div
          className={
            "text-[18px] font-light leading-[1.54] -mt-3 prose-a:text-green flex flex-col gap-4"
          }
          dangerouslySetInnerHTML={{ __html: turnMdToHtml(description) }}
        />
        <div className={"mt-12 flex flex-col justify-center"}>
          <div className={"flex justify-center"}>
            {button.link ? (
              <Link
                to={button.link}
                className={classNames(
                  whiteBackground || grayBackground
                    ? whiteBackground
                      ? "hover:font-semibold"
                      : "hover:font-semibold"
                    : "text-white hover:text-orange hover:bg-white ",
                  "border p-5 uppercase tracking-wider flex"
                )}
              >
                {button.text}
              </Link>
            ) : (
              <div className="flex justify-center" style={{ gap: "12px" }}>
                <button
                  className={classNames(
                    whiteBackground || grayBackground
                      ? whiteBackground
                        ? "hover:font-semibold"
                        : "hover:font-semibold"
                      : "text-white hover:text-orange hover:bg-white ",
                    "border p-5 uppercase tracking-wider flex"
                  )}
                  onClick={button.onClick}
                >
                  {button.text}
                </button>
                {furtherButton && (
                  <button
                    className={classNames(
                      whiteBackground || grayBackground
                        ? whiteBackground
                          ? "hover:font-semibold"
                          : "hover:font-semibold"
                        : "text-white hover:text-orange hover:bg-white ",
                      "border p-5 uppercase tracking-wider flex"
                    )}
                    onClick={furtherButton.onClick}
                  >
                    {furtherButton.text}
                  </button>
                )}
              </div>
            )}
          </div>
          {button.additionalText && button.additionalText.length > 0 && (
            <p className={"font-[16px] normal-case mt-3"}>
              {button.additionalText}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
